export { GlobalLoader, type GlobalLoaderProps } from "./GlobalLoader";
export { SkeletonPlaceholder } from "./SkeletonPlaceholder";
